const deleteModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/common/delete-modal/delete-modal.html',
  controller: 'DeleteModalController',
};

angular
  .module('pis-common.module')
  .component('deleteModal', deleteModal);
